import { trigger } from '@angular/animations';
import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LottieComponent } from 'ngx-lottie';
import { fadeIfSlow } from 'src/app/animations/fade.if-slow.animation';
import { DragDropDirective } from '../../directives/drag-and-drop.directive';
import { StickyComponent } from '../sticky/sticky.component';

@Component({
  selector: 'app-drop',
  templateUrl: './drop.component.html',
  styleUrls: ['./drop.component.scss'],
  animations: [trigger('dragHover', fadeIfSlow)],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DragDropDirective, NgIf, StickyComponent, LottieComponent],
})
export class DropComponent {
  @Output() onFileDrop = new EventEmitter<File[]>();
  @Input() borderStyle: 'normal' | 'full' | 'round' | 'rounded' = 'normal';
  @Input() hoverStyle: 'none' | 'white' | 'replace' = 'none';
  @Input() noTopMargin: boolean;
  @Input() darkBackground: boolean;
  @Input() disable: boolean;
  dragHover = false;

  fileDrop(files: File[]) {
    this.onFileDrop.emit(files);
  }
}
